<template>
  <section class="tree__wrapper">
    <BotTree
      :class="{ 'rounded-border': showSettingDrawer }"
      @open-settings="handleOpen"
      @close-settings="handleClose"
    />

    <Transition name="slide-fade">
      <ConfigurationDrawer
        v-if="showSettingDrawer"
        ref="drawerRef"
        v-model:visible="showSettingDrawer"
        :nodeId="currentOpenedNode"
        :disabled="disabled"
        :deletedQueues="deletedQueues"
        @refresh-bot="emit('refreshBot')"
      />
    </Transition>
  </section>
</template>

<script setup lang="ts">
import { provide, ref } from "vue";

import { CurrentOpenedNodeKey } from "@/@types/ivr/symbols";
import { Bot } from "@/@types/ivr";

import BotTree from "@/app/ivr/bot/components/tree/BotTree.vue";
import ConfigurationDrawer from "@/app/ivr/bot/components/drawer/ConfigurationDrawer.vue";

defineProps<{
  disabled: boolean;
  botDetails?: Bot;
  deletedQueues?: boolean;
}>();

const emit = defineEmits<{
  (e: "refreshBot"): void;
}>();

const drawerRef = ref<InstanceType<typeof ConfigurationDrawer>>();
const currentOpenedNode = ref<number | undefined>(undefined);
const showSettingDrawer = ref(false);

provide(CurrentOpenedNodeKey, currentOpenedNode);

const handleOpen = async (id: number) => {
  if (currentOpenedNode.value === id) return;

  await drawerRef.value?.handleClose();

  currentOpenedNode.value = id;
  showSettingDrawer.value = true;
};

const handleClose = async (ids: number[]) => {
  if (!currentOpenedNode.value) return;
  if (!ids.includes(currentOpenedNode.value)) return;

  await drawerRef.value?.handleClose();
};
</script>

<style scoped lang="sass">
.tree
  &__wrapper
    display: flex
    gap: 4px
    height: 100%

.rounded-border
  border-top-right-radius: 10px
  border-right: 1px solid $gray-5

.slide-fade-enter-active
  transition: all 0.3s ease

.slide-fade-leave-active
  transition: all 0.3s ease

.slide-fade-enter-from, .slide-fade-leave-to
  transform: translateX(100%)
</style>
